export default __webpack_public_path__ + "static/media/jobshub-03-v1.a083f6e1.jpg";